// extracted by mini-css-extract-plugin
export var card = "video_card-module--card--2oWCT";
export var video_card = "video_card-module--video_card--3gT20";
export var thumbnail = "video_card-module--thumbnail--2pCoc";
export var details = "video_card-module--details--KBin8";
export var description = "video_card-module--description--1X0zO";
export var title = "video_card-module--title--3YRLg";